import { Box } from '@mui/material';
import { CreditReportGridData } from './CreditReportGridData';
import { IEmploymentInfo, IEmploymentInformation } from './interfaces/interfaces';

export const EMPLOYMENT_COLUMNS: { header: string; dataKey: keyof IEmploymentInformation }[] = [
  { header: 'Company Name', dataKey: 'companyName' },
  { header: 'Job Title', dataKey: 'jobTitle' },
  { header: 'Employer Address', dataKey: 'employerAddress' },
  { header: 'Origination', dataKey: 'origination' },
  { header: 'Date Reported', dataKey: 'dateReported' },
  { header: 'Date Separated', dataKey: 'dateSeparated' },
  { header: 'Income', dataKey: 'income' },
];

export const EmploymentDetails = ({ employmentInfo }: IEmploymentInfo) => (
  <Box marginBottom={2}>
    <CreditReportGridData
      tableName="Employment"
      data={employmentInfo}
    />
  </Box>
);
